import React, { useEffect } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { Buffer } from 'buffer';

import { faBullhorn, faFilter, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import AccordionComponent from '@component/Accordion'
import BreadcrumbComponent from '@component/Breadcrumb'
import ButtonComponent from '@component/Form/Button'
import DataTableComponent from '@component/Datatable'
import DropdownComponent from '@component/Dropdown'
import SelectComponent from '@component/Form/Select'

import { AclService } from '@service/acl'
import { OmbudsmanManifestationService } from '@service/ombudsman/manifestations'

import Swal from 'sweetalert2'


const breadcrumbItems = [
    { title: 'Home', url: '/dashboard' },
    { title: 'Ouvidoria', url: '/ombudsman' },
    { title: 'Lista de Ocorrências' }
]

let filter = `[{ "field": "status", "operator": "=", "value": true }]`;
filter = new Buffer(filter).toString('base64');

let order = `[
    { "field": "situation", "ordination": "asc" },
    { "field": "manifestation_date", "ordination": "desc" }
]`;
order = new Buffer(order).toString('base64');

let dataFilter = `/ombudsman-manifestations/fetchbyfilter/${filter}/${order}`;


export default function Manifestations() {

    const navigate = useNavigate();

    const { 
        control, 
        formState: { errors }, 
        handleSubmit, 
        register,
        setValue,
        reset
    } = useForm({ mode: 'onChange' })


    const dropdown = (manifestation_id, protocol) => {
        let content = [
            {titulo: 'Visualizar detalhes', parametro: {url: `/ombudsman/manifestations/details/${manifestation_id}`}},
            {titulo: 'Editar ocorrência', parametro: {url: `/ombudsman/manifestations/edit/${manifestation_id}`}},
            // { titulo: 'Excluir ocorrência', parametro: { onclick: 'remove', manifestation_id: manifestation_id, protocol: protocol } }
        ];

        return <DropdownComponent function={dropdownAction} content={content} />
    }


    const dropdownAction = (parametro) => {
        if (!parametro.hasOwnProperty('onclick')) {
            navigate(parametro.url)
        } else eval(parametro.onclick)(parametro.manifestation_id, parametro.protocol)
    }


    const remove = (manifestation_id, protocol) => {
        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            html: `Deseja excluir a ocorrência <strong>${protocol}</strong>?`,
            icon: 'info',
            confirmButtonText: 'Sim',
            confirmButtonColor: '#28a745',
            cancelButtonText: 'Não',
            cancelButtonColor: '#d33',
            showCancelButton: true,
            showCloseButton: true
        }).then(async response => {
            if (response.isConfirmed) {

                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    imageUrl: '/assets/images/loading.gif',
                    imageWidth: 100,
                    imageHeight: 100,
                    text: 'Processando, aguarde...',
                    showConfirmButton: false,
                    width: 300,
                });

                await OmbudsmanManifestationService.remove(manifestation_id)
                    .then(() => {

                        Swal.close();
                        Swal.fire({
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            closeOnEsc: false,
                            html: 'Ocorrência excluída com sucesso',
                            icon: 'success',
                        });

                    });

            }
        })
    }


    const onSubmit = async (data, e) => {
        e.preventDefault();
        console.log(data)
    }


    const columns = [
        {
            cell: (row) => (
                row.protocol ? row.protocol : '-'
            ),
            center: true,
            name: 'Protocolo',
            selector: 'protocol',
            sortable: true,
            width: '12%'
        },
        {
            cell: (row) => (
                row.date ? row.date : '-'
            ),
            center: true,
            name: 'Data',
            selector: 'date',
            sortable: true,
            width: '10%'
        },
        {
            cell: (row) => (
                row.type ? row.type.title : '-'
            ),
            center: true,
            name: 'Tipo de Manifestação',
            selector: 'type',
            sortable: true,
            width: '15%'
        },
        // {
        //     cell: (row) => (
        //         row.category ? row.category.title : '-'
        //     ),
        //     center: true,
        //     name: 'Categoria',
        //     selector: 'category',
        //     sortable: true,
        //     width: '15%'
        // },
        {
            cell: (row) => (
                row.department ? row.department.title : '-'
            ),
            center: true,
            name: 'Departamento',
            selector: 'department',
            sortable: true,
            width: '15%'
        },
        {
            cell: (row) => (
                row.complainer ? AclService.getUser().position.id === 2 ? row.complainer.name : 'Xxxxxxx Xxxxx Xxxxx' : '-'
            ),
            center: true,
            name: 'Manifestante',
            selector: 'complainer',
            sortable: true,
            width: '20%'
        },
        {
            cell: (row) => {
                return (row.situation === 1) ? (
                    <span className='badge bg-secondary'>Em andamento</span>
                ) : (<span className='badge bg-danger'>Concluído</span>)
            },
            center: true,
            name: 'Situação',
            selector: 'status',
            sortable: true,
            width: '10%'
        },
        {
            cell: (row) => {
                return (row.status) ? (
                    <span className='badge bg-success'>Liberado</span>
                ) : (<span className='badge bg-danger'>Bloqueado</span>)
            },
            center: true,
            name: 'Status',
            selector: 'status',
            sortable: true,
            width: '10%'
        },
        {
            cell: (row) => ( dropdown(row.id, row.protocol) ),
            center: true,
            name: 'Ações',
            sortable: false,
            width: '10%'
        }
    ]
    
        
    useEffect(() => {
        setValue('situation', 1);        
    }, [])
    

    return (

        <>

            <div className='header' id='customer_form'>
                <h1 className='header-title'>
                    Lista de Ocorrências
                    <span className='float-end'>
                        <ButtonComponent
                            variant='success'
                            icon={ faBullhorn }
                            title='Nova Ocorrência'
                            type='button'
                            size='md'
                            onClick={() => navigate('/ombudsman/manifestations/create')}
                        />
                    </span>
                </h1>

                <BreadcrumbComponent breadcrumb={breadcrumbItems} />
            </div>
            
            {/* <Row className='mb-3'>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <AccordionComponent
                        default_key={0}
                        data={[{
                            title: 'Filtros', 
                            icon: faFilter, 
                            body: (
                                <Form 
                                    autoComplete='off'
                                    noValidate
                                    onSubmit={handleSubmit(onSubmit)}>
                                
                                    <Row>
                                        <Col lg={2}>
                                            <SelectComponent
                                                control={control}
                                                errors={errors}
                                                label='Situação'
                                                name='situation'
                                                register={register}
                                                required={true}
                                                options={[
                                                    {value: '', label: 'Selecione'},
                                                    {value: 1, label: 'Em andamento'},
                                                    {value: 2, label: 'Concluído'}
                                                ]}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className='text-end'>
                                            <ButtonComponent
                                                variant='success'
                                                icon={faFilter}
                                                id='btn-filter'
                                                title='Filtrar'
                                            />
                                        </Col>
                                    </Row>
                                </Form>
                            )
                        }]}
                    />
                </Col>
            </Row> */}


            <Row className='mb-3'>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <Card>
                        <Card.Body>
                            <DataTableComponent
                                columns={columns}
                                url={dataFilter}
                                title=''
                                pagination={true}
                                subHeader={true}
                                expandable={false}
                                expandableData=''
                                selectableRows={false}
                                selectableRowsNoSelectAll={false}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

        </>

    )
}
